import axios from "axios";
import {  
  PRODUCT_SERVER,
  PRODUCT_DETAIL_SERVER,
  PRODUCT_IMAGE_DETAIL_SERVER, 
  PRODUCT_RELATED_SERVER,
  SEARCH_PRODUCTS_SERVER,
  GET_PRODUCTS_BEST_SELLER_SERVER,
  CHECK_STOCK_PRODUCT_SERVER,
  GET_PRODUCTS_RATING_SERVER,
  UPDATE_PRODUCTS_RATING_SERVER,
  GET_PRODUCTS_INTEREST_SERVER,
  PRODUCT_ALL_SERVER,
  UPDATE_PRODUCT_SERVER,
  CREATE_PRODUCT_SERVER,
  DELETE_PRODUCT_SERVER,
  GET_CATEGORIES_SERVER,
} from "../../utils/misc";
import {
  GET_PRODUCT,
  GET_PRODUCT_DETAIL,
  GET_PRODUCT_IMAGE_DETAIL,
  GET_PRODUCT_RELATED,
  CLEAR_PRODUCT_DETAIL,
  SEARCH_PRODUCTS,
  GET_PRODUCTS_BEST_SELLER,
  CHECK_STOCK_PRODUCT,
  GET_PRODUCTS_RATING,
  UPDATE_PRODUCTS_RATING,
  GET_PRODUCTS_INTEREST,
  GET_CATEGORIES,
} from "./types";

export async function getProducts(dataToSubmit) {
  const data = { categoryName: dataToSubmit };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(PRODUCT_SERVER, { params: data }, { headers: headers }).then((res) => {
    let products = res.data.data;
    return {
      products
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT,
    payload: request,
  };
}

export function getProductsBestSeller() {
  const request = axios.get(GET_PRODUCTS_BEST_SELLER_SERVER).then((res) => {     
    let products = res.data.data;
    return {
      products,
    };
  });
  return {
    type: GET_PRODUCTS_BEST_SELLER,
    payload: request,
  };
}

export async function getProductsInterest() {
  let customerId = -1;
  if(JSON.parse(localStorage.getItem("user"))) {
    let userInfo = JSON.parse(localStorage.getItem("user"));
    customerId = userInfo.customerID;
  }

  const data = { id: customerId }

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_PRODUCTS_INTEREST_SERVER, { params: data }, { headers: headers }).then((res) => {
    let products = res.data.data;
    return {
      products
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCTS_INTEREST,
    payload: request,
  };
}

export async function getProductDetail(id, keyword) {
  const data = { ProductId: id };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(PRODUCT_DETAIL_SERVER, { params: data }, { headers: headers }).then((res) => {
    let product = res.data.data;
    return {
      product
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT_DETAIL,
    payload: request,
  };
}

export async function getProductImageDetail(id, keyword) {
  const data = { ProductId: id };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(PRODUCT_IMAGE_DETAIL_SERVER, { params: data }, { headers: headers }).then((res) => {
    let productImage = res.data.data;
    return {
      productImage
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT_IMAGE_DETAIL,
    payload: request,
  };
}

export async function getProductRelated(productId, categoryName) {
  const data = { 
    ProductId : productId,
    CategoryName : categoryName 
  };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(PRODUCT_RELATED_SERVER, { params: data }, { headers: headers }).then((res) => {
    let products = res.data.data;
    return {
      products,
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT_RELATED,
    payload: request,
  };
}

export async function searchProducts(page, searchValue, previousState = []) {
  const data =   {
    page: page,
    size: 6,
    id: 0,
    type: "string",
    keyword: searchValue,
    date: "string"
  }

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(SEARCH_PRODUCTS_SERVER, data, { headers: headers }).then((res) => {
    // let searchResult = res.data;
    let dataResult = res.data.data
    let newState = [...previousState, ...dataResult.data]
    return {
      searchResult: newState,
      totalPages: res.data.data.totalPages,
      totalResult: res.data.data.totalRecord
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: SEARCH_PRODUCTS,
    payload: request,
  };
}

export function clearProductDetail() {
  return {
    type: CLEAR_PRODUCT_DETAIL,
    payload: "",
  };
}

export async function checkStockProduct(dataToSubmit) {
  const data = { checkStockList : dataToSubmit };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(CHECK_STOCK_PRODUCT_SERVER, data, { headers: headers }).then((res) => {
    let productChecked = res.data.data;
    return {
      productChecked
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: CHECK_STOCK_PRODUCT,
    payload: request,
  };
}

export async function getProductsRating(orderId, customerId) {
  const config = {
    header: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    },
    params: {
      OrderId: orderId,
      CustomerId: customerId
    }    
  }  
  //////////////////////
  const request = await axios.get(GET_PRODUCTS_RATING_SERVER, config).then((res) => {
    let productRating = res.data.data;
    localStorage.setItem("productRating", JSON.stringify(productRating))
    return {
      productRating
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCTS_RATING,
    payload: request,
  };
}

export async function updateProductsRating(dataToSubmit) {
  let productRating = JSON.parse(localStorage.getItem('productRating'))
  let reqListData = productRating.map(element => {
    return {
      productId: element.productId,
      ratingStar: element.ratingStar
    }
  })

  let data = {
    orderId: dataToSubmit,
    reqList: reqListData
  }

  let token = JSON.parse(localStorage.getItem("token"));  
  const headers = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
  }  
  //////////////////////
  
  const request = await axios.put(UPDATE_PRODUCTS_RATING_SERVER, data, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: UPDATE_PRODUCTS_RATING,
    payload: request,
  };
}

//Get all products
export async function getAllProducts() {
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(PRODUCT_ALL_SERVER, null, { headers: headers }).then((res) => {
    let products = res.data;
    return {
      products
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_PRODUCT,
    payload: request,
  };
}

export async function getCategories() {
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_CATEGORIES_SERVER, { headers: headers }).then((res) => {
    let categories = res.data.data;
    return {
      categories
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_CATEGORIES,
    payload: request,
  };
}

//Save product
export async function saveProduct(data) {
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  let url = "";
  if (data.productId && data.productId != 0) {
    url = UPDATE_PRODUCT_SERVER;
  }
  else {
    url = CREATE_PRODUCT_SERVER;
  }
  const request = await axios.post(url, data, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT,
    payload: request,
  };
}

export async function deleteProduct(id) {
  const data = {
    id: id
  }

  let token = JSON.parse(localStorage.getItem("token"))
  const headers = {
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.delete(DELETE_PRODUCT_SERVER, { params: data }, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PRODUCT,
    payload: request,
  };
}